"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _sortable = require("@dnd-kit/sortable");

var _utilities = require("@dnd-kit/utilities");

var _propTypes = require("prop-types");

var _TableCell = _interopRequireDefault(require("../TableCell/TableCell"));

var _DraggingTableRowCells = _interopRequireDefault(require("./DraggingTableRowCells"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TableRow = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var _row$original;

  var row = _ref.row;

  var _useSortable = (0, _sortable.useSortable)({
    id: row.original.id
  }),
      attributes = _useSortable.attributes,
      listeners = _useSortable.listeners,
      transform = _useSortable.transform,
      transition = _useSortable.transition,
      setNodeRef = _useSortable.setNodeRef,
      isDragging = _useSortable.isDragging;

  var dragHandle = (0, _react.useMemo)(function () {
    return {
      attributes: attributes,
      listeners: listeners
    };
  }, [attributes, listeners]);
  var style = {
    transform: _utilities.CSS.Transform.toString(transform),
    transition: transition
  };
  return (0, _jsxRuntime.jsx)("tr", _objectSpread(_objectSpread({
    ref: setNodeRef,
    className: (0, _clsx["default"])({
      disabled: !!(row !== null && row !== void 0 && (_row$original = row.original) !== null && _row$original !== void 0 && _row$original.isDisabled)
    }),
    style: style
  }, row.getRowProps()), {}, {
    children: isDragging ? (0, _jsxRuntime.jsx)(_DraggingTableRowCells["default"], {
      colSpan: row.cells.length
    }) : row.cells.map(function (cell, index) {
      return (0, _jsxRuntime.jsx)(_TableCell["default"], {
        cell: cell,
        index: index,
        dragHandle: dragHandle
      }, cell.getCellProps().key);
    })
  }));
});

TableRow.displayName = 'TableRow';
TableRow.propTypes = {
  row: (0, _propTypes.shape)({}).isRequired
};
TableRow.defaultProps = {};
var _default = TableRow;
exports["default"] = _default;
//# sourceMappingURL=TableRow.js.map